import { ComponentPropsWithoutRef, ReactNode } from 'react'
import { mtc, TextColors, TypographyStyles } from '@/styles'
import { styles } from './styles'

export interface TextProps extends ComponentPropsWithoutRef<'p'> {
  as?: TypographyStyles
  children?: ReactNode
  className?: string
  color?: TextColors
  testId?: string
  textAlign?: 'center' | 'left' | 'right'
  variant?: TypographyStyles
  underlined?: boolean
}

export const Text = ({
  as,
  children,
  className,
  color,
  testId,
  textAlign,
  variant,
  underlined,
  ...props
}: TextProps) => {
  if (!variant && as) {
    variant = as
  }

  return (
    <p
      className={mtc(
        styles({ textAlign, color, variant, underlined }),
        className
      )}
      data-testid={testId}
      {...props}
    >
      {children}
    </p>
  )
}
